import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '../../notes/icon/icon.module';
import { DigitalDataModule } from '../../shared/modules/digital-data/digital-data.module';
import { InfoPanelComponent } from './info-panel.component';
import { InfoPanelEventPipe, InfoPanelPhoneEventPipe } from './info-panel.pipe';

@NgModule({
  declarations: [
    InfoPanelComponent,
    InfoPanelEventPipe,
    InfoPanelPhoneEventPipe,
  ],
  imports: [CommonModule, DigitalDataModule, IconModule],
  exports: [InfoPanelComponent, InfoPanelEventPipe, InfoPanelPhoneEventPipe],
})
export class InfoPanelModule {}
